import { useQuery } from '../models/reactUtils'
import { observer } from 'mobx-react'
import React from 'react'
import { useTranslation } from 'react-i18next'

import Box from '@mui/material/Box'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'

import Loading from './Loading'
import LocationsList from './LocationsList'
import ProvidersList from './ProvidersList'

const ResultsPanel = ({ toggleDrawer }) => {
  const { store } = useQuery()
  const { t } = useTranslation()
  const searchHasNoResults = store.searchStore.searchHasNoResults
  if (searchHasNoResults) {
    return (
      <Box
        aria-label="Result Panel"
        sx={{ display: 'flex', flexDirection: 'column', overflowY: 'hidden' }}
      >
        <List sx={{ py: 0 }}>
          <Paper
            elevation={1}
            square
            sx={{
              pt: { xs: 0, md: 10 },
              pb: { xs: 2, md: 2 },
            }}
          >
            <Typography variant="subtitle2" align="center">
              {t(`No results found`)}
            </Typography>
          </Paper>
          <ListItem sx={{ px: 3, py: 2 }}>
            <Typography variant="body1">{t('No Results')}</Typography>
          </ListItem>
        </List>
      </Box>
    )
  }
  return (
    <Box
      aria-label="Result Panel"
      sx={{ display: 'flex', flexDirection: 'column', overflowY: 'hidden' }}
    >
      {store.loading ? <Loading message="Loading results..." /> : null}
      {store.showResults === 'locations' && (
        <LocationsList toggleDrawer={toggleDrawer} />
      )}
      {store.showResults === 'providers' && (
        <ProvidersList toggleDrawer={toggleDrawer} />
      )}
    </Box>
  )
}

export default observer(ResultsPanel)
